export type Attachment = {
  id: string;
  name: string;
  size: string;
  type: 'pdf' | 'image' | 'zip' | 'doc' | 'other';
};

export type Message = {
  id: string;
  from: string;
  fromEmail: string;
  subject: string;
  preview: string;
  body: string;
  receivedAt: string;
  isRead: boolean;
  starred: boolean;
  trashed: boolean;
  size: string;
  attachments: Attachment[];
  avatarUrl: string;
  avatarAlt: string;
};

export const mockMessages: Message[] = [
{
  id: 'msg-001',
  from: 'GitHub',
  fromEmail: 'noreply@github.com',
  subject: 'Please verify your email address',
  preview: 'Hey, we need you to verify your email before you can access your new repository...',
  body: `<p>Hi there,</p><p>Thanks for signing up for GitHub. Before you can start pushing code, we need to verify your email address.</p><p>Your verification code is: <strong style="font-family: monospace; font-size: 1.1em; color: #7C5CFC; letter-spacing: 0.1em;">847291</strong></p><p>This code expires in 10 minutes. If you did not create a GitHub account, you can safely ignore this email.</p><p>— The GitHub Team</p>`,
  receivedAt: '2026-09-01T23:38:00Z',
  isRead: false,
  starred: false,
  trashed: false,
  size: '14 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_15430be3f-1766708087800.png",
  avatarAlt: 'GitHub logo on dark background'
},
{
  id: 'msg-002',
  from: 'Vercel',
  fromEmail: 'no-reply@vercel.com',
  subject: 'Your deployment is live',
  preview: 'Your project my-saas-app has been deployed to production. Visit it at...',
  body: `<p>Great news — your deployment completed successfully.</p><p><strong>Project:</strong> my-saas-app<br/><strong>Branch:</strong> main<br/><strong>Status:</strong> Ready<br/><strong>URL:</strong> <a href="#">https://my-saas-app.vercel.app</a></p><p>Build time: 43 seconds. No warnings.</p><p>— Vercel</p>`,
  receivedAt: '2026-09-01T23:21:00Z',
  isRead: false,
  starred: true,
  trashed: false,
  size: '9 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1fad0cf7b-1766774485998.png",
  avatarAlt: 'Vercel triangle logo on dark background'
},
{
  id: 'msg-003',
  from: 'Stripe',
  fromEmail: 'receipts@stripe.com',
  subject: 'Your receipt from Stripe — $49.00',
  preview: 'Thank you for your payment. Your receipt for $49.00 is attached to this email...',
  body: `<p>Hi Alex,</p><p>Thank you for your payment. Here is your receipt.</p><p><strong>Amount:</strong> $49.00 USD<br/><strong>Date:</strong> September 1, 2026<br/><strong>Description:</strong> TempMail Pro — Monthly Subscription<br/><strong>Invoice #:</strong> INV-2026-09-001</p><p>A PDF copy of your invoice is attached.</p>`,
  receivedAt: '2026-09-01T22:55:00Z',
  isRead: true,
  starred: false,
  trashed: false,
  size: '62 KB',
  attachments: [
  { id: 'att-003-1', name: 'invoice-sep-2026.pdf', size: '48 KB', type: 'pdf' }],

  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_11a6c5b7a-1769669182475.png",
  avatarAlt: 'Stripe payment processing logo'
},
{
  id: 'msg-004',
  from: 'Linear',
  fromEmail: 'notifications@linear.app',
  subject: 'TEM-142 has been assigned to you',
  preview: 'Priya Nair assigned you to "Add attachment preview to message reader" in the TempMail project...',
  body: `<p><strong>Issue assigned</strong></p><p>Priya Nair assigned you to issue <strong>TEM-142</strong>: Add attachment preview to message reader.</p><p><strong>Priority:</strong> High<br/><strong>Estimate:</strong> 3 points<br/><strong>Due:</strong> Sep 5, 2026</p><p>View the issue in Linear to add comments or update the status.</p>`,
  receivedAt: '2026-09-01T21:40:00Z',
  isRead: true,
  starred: true,
  trashed: false,
  size: '7 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1d543306e-1775494585592.png",
  avatarAlt: 'Linear project management app interface'
},
{
  id: 'msg-005',
  from: 'Figma',
  fromEmail: 'noreply@figma.com',
  subject: 'Kavya Reddy shared a file with you',
  preview: 'Kavya Reddy invited you to view "TempMail — Design System v2" in Figma...',
  body: `<p>Hi Alex,</p><p><strong>Kavya Reddy</strong> has shared a Figma file with you.</p><p><strong>File:</strong> TempMail — Design System v2<br/><strong>Access:</strong> Can view</p><p>Open the file to inspect components, copy CSS, and export assets.</p>`,
  receivedAt: '2026-09-01T19:15:00Z',
  isRead: true,
  starred: false,
  trashed: false,
  size: '11 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_13002b75f-1766792816373.png",
  avatarAlt: 'Figma design tool interface screenshot'
},
{
  id: 'msg-006',
  from: 'Notion',
  fromEmail: 'notify@mail.notion.so',
  subject: 'Weekly digest — 4 updates in TempMail workspace',
  preview: 'Here is a summary of recent activity in your shared workspace: 3 pages edited, 1 database entry added...',
  body: `<p>Your weekly workspace digest is ready.</p><ul><li><strong>Roadmap Q4 2026</strong> — edited by Rohan Sharma</li><li><strong>Sprint 14 Notes</strong> — new entry added by Kavya Reddy</li><li><strong>API Documentation</strong> — 2 sections updated</li><li><strong>Bug Tracker</strong> — 3 items closed</li></ul><p>Open Notion to review all changes.</p>`,
  receivedAt: '2026-09-01T09:00:00Z',
  isRead: true,
  starred: false,
  trashed: false,
  size: '18 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1ffb9ca14-1770923433011.png",
  avatarAlt: 'Notion workspace notes and productivity tool'
},
{
  id: 'msg-007',
  from: 'Cloudflare',
  fromEmail: 'noreply@cloudflare.com',
  subject: 'Action required: SSL certificate expiring in 7 days',
  preview: 'Your SSL certificate for mailnova.io is expiring on September 8, 2026. Renew it now to avoid downtime...',
  body: `<p><strong>Certificate Expiry Warning</strong></p><p>The SSL certificate for <strong>mailnova.io</strong> will expire on <strong>September 8, 2026</strong>.</p><p>If you do not renew before this date, your domain will show security warnings to visitors and email delivery may be disrupted.</p><p>Log in to your Cloudflare dashboard to renew or configure auto-renewal.</p>`,
  receivedAt: '2026-09-01T08:22:00Z',
  isRead: false,
  starred: false,
  trashed: false,
  size: '8 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1798da47b-1767421073019.png",
  avatarAlt: 'Cloudflare network security dashboard'
},
{
  id: 'msg-008',
  from: 'Supabase',
  fromEmail: 'noreply@supabase.io',
  subject: 'Your database is approaching its row limit',
  preview: 'Your project tempmail-prod is at 87% of the free tier row limit. Upgrade to Pro to avoid write blocks...',
  body: `<p><strong>Usage Alert</strong></p><p>Your Supabase project <strong>tempmail-prod</strong> has reached <strong>87%</strong> of the free tier row limit (500,000 rows).</p><p>When you hit 100%, new writes will be blocked. Upgrade to Pro to continue growing.</p><p>Current usage: 435,214 rows / 500,000</p>`,
  receivedAt: '2026-08-31T16:45:00Z',
  isRead: true,
  starred: false,
  trashed: false,
  size: '6 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_106f0ed3c-1766591677157.png",
  avatarAlt: 'Database server infrastructure close-up'
},
{
  id: 'msg-009',
  from: 'PlanetScale',
  fromEmail: 'billing@planetscale.com',
  subject: 'Invoice #PS-2026-0831 — $0.00',
  preview: 'Your PlanetScale invoice for August 2026 is ready. Total amount due: $0.00...',
  body: `<p>Hi Alex,</p><p>Your PlanetScale invoice for August 2026 is ready.</p><p><strong>Total due:</strong> $0.00 (Hobby plan)<br/><strong>Period:</strong> Aug 1 – Aug 31, 2026</p><p>No payment is required for this period. Your next billing cycle starts September 1.</p>`,
  receivedAt: '2026-08-31T10:00:00Z',
  isRead: true,
  starred: false,
  trashed: true,
  size: '5 KB',
  attachments: [
  { id: 'att-009-1', name: 'invoice-aug-2026.pdf', size: '22 KB', type: 'pdf' }],

  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_142e9fa98-1788306516460.png",
  avatarAlt: 'PlanetScale database platform logo'
},
{
  id: 'msg-010',
  from: 'Resend',
  fromEmail: 'hello@resend.com',
  subject: 'Welcome to Resend — your first email is sending',
  preview: 'Welcome, Alex! Your account is set up and your first transactional email is in the queue...',
  body: `<p>Welcome to Resend, Alex!</p><p>Your account is active and your first transactional email is being sent right now. Here are your API details to get started:</p><p><strong>API Key:</strong> re_••••••••••••••••••••••••<br/><strong>Sending domain:</strong> mailnova.io<br/><strong>Daily limit:</strong> 3,000 emails</p><p>Check the dashboard to monitor delivery rates, opens, and bounces.</p>`,
  receivedAt: '2026-08-30T14:33:00Z',
  isRead: true,
  starred: false,
  trashed: false,
  size: '10 KB',
  attachments: [],
  avatarUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_129f649f9-1788306514462.png",
  avatarAlt: 'Email delivery service abstract background'
}];